import {
    faEdit,
    faFilter,
    faFolder,
    faPlus,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UnForm from "../../../Components/Form";

import StickyToolbar from "../../../Components/StickyToolbar";
import Table from "../../../Components/Table";
import {
    ListarDocumentoTemplateFiltroController,
    ListarModulosController,
} from "../../../Controllers/Geral/Documentos/DocumentosController";
import {
    IDocumentosTemplate,
    IFiltroDocumentosTemplate,
} from "../../../Interfaces/Geral/Documentos/DocumentosInterface";
import AtivaDesativaTemplate from "./AtivaDesativaTemplates";
import { Link } from "react-router-dom";
import "./styles.css";
import { ListarEmpreendimentosComObraController } from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import { FormProvider, useForm } from "react-hook-form";
import { useState } from "react";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import ModalComponent from "../../../Components/Modais";
import GerenciarModulosTemplates from "./GerenciarModulosTemplates/GerenciarModulosTemplates";

const filtroInicial: IFiltroDocumentosTemplate = {
    DS_DESCRICAO: undefined,
    ID_TIPO_CASO: undefined,
    ID_EMPREENDIMENTO: undefined,
    FL_ATIVO: true,
};

export default function GestaoTemplates() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const FormMethods = useForm();

    const { reset } = FormMethods;

    const { filter, setFilter } = usePaginationFilter({
        page: 1,
        filter: filtroInicial,
    });

    const {
        value: listarTemplatesResponse,
        loading: updateListLoading,
        execute: updateList,
    } = useAsyncEffect(async () => {
        return ListarDocumentoTemplateFiltroController({
            DS_DESCRICAO: filter?.DS_DESCRICAO
                ? filter?.DS_DESCRICAO
                : undefined,
            ID_TIPO_CASO: filter?.ID_TIPO_CASO
                ? filter?.ID_TIPO_CASO
                : undefined,
            ID_EMPREENDIMENTO: filter?.ID_EMPREENDIMENTO
                ? filter?.ID_EMPREENDIMENTO
                : undefined,
            FL_ATIVO: filter?.FL_ATIVO,
        });
    }, [filter]);

    function handleSubmit(formData: IFiltroDocumentosTemplate) {
        const filterFormData = {
            ...formData,
        };
        setFilter(filterFormData);
    }

    function RowTable(cell: any, row: IDocumentosTemplate) {
        return (
            <>
                <div className="rowCapys">
                    <div>
                        <h4>{row.DS_DOCUMENTO}</h4>
                        {row.DS_PRODUTO && (
                            <div className="d-flex align-items-center flex-lg-fill mr-5 mb-2">
                                <div className="d-flex flex-column text-dark-75">
                                    <span className="font-weight-bolder font-size-sm">
                                        Produto
                                    </span>
                                    <span className="font-weight-bolder font-size-h6">
                                        {row.DS_PRODUTO}
                                    </span>
                                </div>
                            </div>
                        )}
                        <div className="StatusGrupo">
                            {row.FL_ATIVO ? (
                                <span className="label label-pill label-inline label-success mr-2">
                                    {" "}
                                    Ativo
                                </span>
                            ) : (
                                <span className="label label-pill label-inline label-danger mr-2">
                                    {" "}
                                    Desativado
                                </span>
                            )}
                        </div>
                        {row.MODULOS && row.MODULOS?.length > 0 && (
                            <div className="d-flex flex-column justify-content-start">
                                <div className="d-flex align-items-center flex-wrap">
                                    {row.MODULOS.map((modulo) => {
                                        return (
                                            <span
                                                key={modulo.DS_MODULO}
                                                className="label label-light-info label-inline mr-2 my-1"
                                                style={{
                                                    height: "auto",
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faFolder}
                                                    className="mr-1"
                                                />{" "}
                                                {modulo.DS_MODULO}
                                            </span>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="Button-Tools d-flex align-items-center ju">
                        <button
                            className="btn btn-outline-success font-weight-bold mr-2"
                            onClick={() => {
                                setModal({
                                    Children: (
                                        <GerenciarModulosTemplates row={row} />
                                    ),
                                    IconHeader: faFolder,
                                    headerComponent: "Módulos",
                                    noFooter: true,
                                    size: "xl",
                                });
                                setShow(true);
                            }}
                        >
                            <FontAwesomeIcon icon={faFolder} size="lg" />{" "}
                            Módulos
                        </button>
                        <Link
                            to={`/Geral/GestaoTemplates/ConfigurarTemplates/${row.ID_DOCUMENTO_TEMPLATE}`}
                            className="btn btn-outline-primary font-weight-bold mr-2"
                        >
                            <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                        </Link>

                        <AtivaDesativaTemplate
                            row={row}
                            ID_DOCUMENTO_TEMPLATE={row.ID_DOCUMENTO_TEMPLATE}
                            FL_ATIVO={row.FL_ATIVO}
                            then={() => updateList()}
                        />
                    </div>
                </div>
            </>
        );
    }

    const ColunsUser = [
        {
            dataField: "DS_DOCUMENTO",
            text: "Descrição",
            formatter: RowTable,
            sort: true,
        },
    ];

    return (
        <>
            <div className="card card-custom">
                <div className="card-header card-header-tabs-line d-flex align-items-center">
                    <h3 className="card-title align-items-start ">
                        <span className="card-label font-weight-bolder text-dark gruposTitle">
                            Gestão de Templates
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <Link
                            to={`/Geral/GestaoTemplates/ConfigurarTemplates/0`}
                            className="btn btn-primary font-weight-bold mr-2 linkSemIcone"
                        >
                            <FontAwesomeIcon icon={faPlus} className="mr-2" />
                            Cadastrar Template
                        </Link>
                    </div>
                </div>
                <div className="card-body">
                    <Table
                        data={listarTemplatesResponse ?? []}
                        loading={updateListLoading}
                        bordered={false}
                        striped={true}
                        columns={ColunsUser}
                        keyField="ID_DOCUMENTO_TEMPLATE"
                        center
                    />
                </div>
            </div>
            <StickyToolbar>
                <FormProvider {...FormMethods}>
                    <UnForm handleSubmit={handleSubmit} usingContext>
                        <div className="form-group row">
                            <div className="col-12">
                                <UnForm.LazySelect
                                    label="Modulo"
                                    name="ID_TIPO_CASO"
                                    controller={ListarModulosController}
                                    getDS={(e) => e.DS_MODULO}
                                    getKeyValue={(e) => e.ID_MODULO}
                                    disabled={updateListLoading}
                                    {...FormMethods}
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                            <div className="col-12 mt-3">
                                <label>Nome do template</label>
                                <UnForm.Input
                                    className="form-control"
                                    type="text"
                                    name="DS_DESCRICAO"
                                    disabled={updateListLoading}
                                />
                            </div>
                            <div className="col-12 mt-3">
                                <UnForm.LazySelect
                                    label="Empreendimento"
                                    name="ID_EMPREENDIMENTO"
                                    controller={
                                        ListarEmpreendimentosComObraController
                                    }
                                    getDS={(e) => e.DS_EMPREENDIMENTO}
                                    getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                                    disabled={updateListLoading}
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                            <div className="col-12 mt-3">
                                <label>Ativo</label>
                                <div className="d-flex justify-content-start">
                                    <UnForm.Switch
                                        color="success"
                                        name="FL_ATIVO"
                                        type="checkbox"
                                        defaultChecked={true}
                                    />
                                </div>
                            </div>
                            <UnForm.SubmitButton
                                color="dark"
                                wrapperClassName="col-12 w-100 pt-2"
                                className="col-12 btn-outline-dark"
                                icon={faFilter}
                                disabled={updateListLoading}
                            >
                                Filtrar
                            </UnForm.SubmitButton>
                            <div className="col-12 d-flex align-items-end justify-content-start">
                                <button
                                    type="button"
                                    className="btn btn-block btn-outline-danger mt-2"
                                    onClick={() => {
                                        reset(filtroInicial);
                                        setFilter(filtroInicial);
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        className="mr-2"
                                    />
                                    Limpar Filtros
                                </button>
                            </div>
                        </div>
                    </UnForm>
                </FormProvider>
            </StickyToolbar>
            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </>
    );
}
